<template>
  <div>
    <v-select
      v-model="selected"
      :label="label"
      :options="options"
      :placeholder="$t('vueSelect.placeholder')"
      :reset-on-options-change="resetOnOptionsChange"
      :multiple="multiple"
      :clearable="clearable"
      :disabled="disabled"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template #no-options="{ search, searching, loading }">
        {{ $t('vueSelect.noResults') }}
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes" />
        <i
          :class="icon"
          class="additional-p"
        />
      </template>
    </v-select>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import vSelect from 'vue-select'

export default defineComponent({
  name: 'VueSelect',
  components: { vSelect },
  data() {
    return {
      selected: null,
      isUpdatingFromProp: false
    }
  },
  props: {
    options: { type: Object },
    label: { type: String },
    icon: { type: String },
    value: { type: Object },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    resetOnOptionsChange: {type: Boolean, default: true}
  },
  watch: {
    selected: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !this.isUpdatingFromProp) {
          this.updateValue(newValue)
        }
      }
    },
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.isUpdatingFromProp = true
          this.selected = newValue
          this.$nextTick(() => {
            this.isUpdatingFromProp = false
          })
        }
      },
      deep: true
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('updateSelect', value)
    }
  },
  
})
</script>
<style lang="scss">
.v-select {
  background: #fff;
}

.vs__dropdown-toggle {
  padding: 0 0 5px !important;
  border: 1px solid #ddd !important;
}

.vs__selected-options {
  margin: 0 !important;
  padding: 1px 0 0 28px !important;
}

.bi.additional-p {
  position: absolute;
  left: 6px;
  padding: 0 6px;
}

input::placeholder {
  color: #a3a3a2 !important;
}
</style>